module.exports = __webpack_public_path__ + "static/media/uk.39195acc.svg";